import { ModulePublishingState } from '../../../../@types/module-publishing-state';
import Role from '../../../../core/security/role';

import Alert from '@pelckmans/elementis/components/alert';
import { useTranslation } from 'react-i18next';
import { getRoleTranslationKey } from './utils';

interface ModuleStatusAlertProps {
  status: ModulePublishingState;
  role: Role;
  isAuthor?: boolean;
}

export default function ModuleStatusAlert({ status, role, isAuthor }: ModuleStatusAlertProps) {
  const { t } = useTranslation();
  switch (status) {
    case 'phasedOut':
      return <Alert prominence="info">{t('PAGES.TOC_LEVEL.ALERTS.PHASED_OUT_MODULES.MESSAGE')}</Alert>;
    case 'preview':
      return (
        <Alert prominence="info">
          {t('PAGES.TOC_LEVEL.ALERTS.PREVIEW_MODULES.MESSAGE', { role: t(getRoleTranslationKey(role, isAuthor)) })}
        </Alert>
      );
    case 'review':
      return (
        <Alert prominence="info">
          {t('PAGES.TOC_LEVEL.ALERTS.REVIEW_MODULES.MESSAGE', { role: t(getRoleTranslationKey(role, isAuthor)) })}
        </Alert>
      );
    default:
      return null;
  }
}
